import { Component } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { Constants } from '../common/constants';
import { Utils } from '../common/utils';

export interface FilePdfjsViewInterface {
  fileBase64Data: string;
  fileType: string;
}
@Component({
  selector: 'app-file-pdfjs-view-modal',
  templateUrl: './file-pdfjs-view-modal.component.html',
  styleUrls: ['./file-pdfjs-view-modal.component.css']
})
export class FilePdfjsViewModalComponent extends SimpleModalComponent<FilePdfjsViewInterface, string> implements FilePdfjsViewInterface {

  fileBase64Data: string;
  fileType: string;

  // convert base64 to blob or uint8array for ng2-pdfjs-viewer
  get pdfBlobUrl(): string | Uint8Array {
     if (this.fileBase64Data && this.fileBase64Data.startsWith('data:application/pdf;base64,')) {
         const base64 = this.fileBase64Data.split(',')[1];
         const binaryString = window.atob(base64);
         const len = binaryString.length;
         const bytes = new Uint8Array(len);
         for (let i = 0; i < len; i++) {
             bytes[i] = binaryString.charCodeAt(i);
         }
         return bytes;
     }
     return this.fileBase64Data;
  }

  constructor(public constants: Constants, public utils: Utils) { 
    super();
  }

  closeModal() {
    this.close();
  }

}
